import {
  ChangeDetectionStrategy,
  Component,
  signal,
  effect,
  inject,
} from '@angular/core';
import { share } from 'rxjs';
import { SharedModule } from '../shared.module';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../footer/footer.component';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { permissionEntity } from '../../core/constants/permission';
import { PermissionsPipe } from '../../core/pipe/permissions.pipe';
import { MailServiceService } from '../../../app/core/service/mail/mail-service.service';
import { LocalStorageService } from '../../../app/core/service/localStorage/local-storage.service';
import { ChangeDetectorRef } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileMangerService } from '../../core/service/file-manger/file-manger.service';
import { DomainConfigService } from '../../core/service/domainConfig/domain-config.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { TwoFactorVerificationComponent } from '../../features/user-profile/common/two-factor-verification/two-factor-verification.component';
import { LoaderService } from '../../core/service/loader.service';
import { PopupServiceService } from '../../core/service/popup/popup-service.service';
import { SwitchUserComponent } from '../../features/file-manager-v3/switch-user/switch-user.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [SharedModule, CommonModule, FooterComponent, PermissionsPipe, MatTooltipModule, RouterLink, RouterLinkActive, MatDialogModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  brandLogo = './assets/images/logo.svg';
  brandLogoIcon = './assets/images/logo-icon.svg';

  redirectToDashboard() {
    this.router.navigate(['/dashboard/all-application']);
  }
  /** User Mail Activity is unfinished: only local runs set this. */
  readonly showUserMailActivity = (environment as { showUserMailActivity?: boolean }).showUserMailActivity === true;

  get isOnMailPage(): boolean {
    return this.router.url === '/mail';
  }

  private readonly mailService = inject(MailServiceService);
  private localStorageService = inject(LocalStorageService);
  private readonly fileMangerService = inject(FileMangerService);
  private readonly _localStorageService = inject(LocalStorageService);
  private readonly LoaderService = inject(LoaderService);
  private readonly toast = inject(PopupServiceService);
  private domainConfigService = inject(DomainConfigService);
  private dialog = inject(MatDialog);
  readonly panelOpenState = signal(false);
  permissions_entity = permissionEntity;
  dashboardData: any; // for "All Mails"
  dashboardDataMap: { [email: string]: any } = {}; // per account
  userAccounts: any[] = [];
  userDetails: any;
  universityIds: any;
  userType: any;
  studiesplanet: any;
  globalTree: any;
  token:string | null = null;

  constructor(private router: Router, private cdr: ChangeDetectorRef) {
    this.setupDomainBranding();
  }

  goToApplications(event: MouseEvent) {
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }

    this.router.navigate(['/dashboard/all-application']);
  }

  goToUkMockInterview(event: MouseEvent) {
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }

    this.router.navigate(['/dashboard/uk-mock-interview']);
  }
  goToAgent(event: MouseEvent) {
    // Allow Ctrl / Cmd / Middle-click → new tab
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }

    // Normal click → SPA navigation
    event.preventDefault();
    this.router.navigate(['/dashboard/agent']);
  }
  goToNonApprovedAgent() {
    this.router.navigate(['/dashboard/agent/nonApproveAgent']);
  }
  goToSearchAgent() {
    this.router.navigate(['/dashboard/agent/searchAgent']);
  }
  goToCounsellor() {
    this.router.navigate(['/dashboard/agent/counsellor']);
  }
  //   getSearchAgentLink() {
  //   return ['/dashboard/agent/searchAgent'];
  // }


  async ngOnInit(): Promise<void> {
    await this.loadCurrentUser();
    this.token = this.localStorageService.getKey('access_token');
  }

  async loadCurrentUser() {
    try {
      const res = await this._localStorageService.getKeyIndexedDbKey('currentUser');
      this.userDetails = res;
      this.studiesplanet = this.userDetails?.roles?.[0]?.id === '160';
      this.globalTree = this.userDetails?.roles?.[0]?.id === '156';
    } catch (err) {
      console.error('Error loading user:', err);
    }
    // console.log('userDetails', this.studiesplanet);

  }

  // ============================= //
  //   APPLICATION ARCHIVEED       //
  // ============================= //

  goToArchivedApplications() {
    this.router.navigate(['/dashboard/all-application/archived']);
  }

  // ============================= //
  //      STUDENT INTERVIEW        //
  // ============================= //

  goToInterviewMaster() {
    this.router.navigate(['/dashboard/cct']);
  }

  goToInterviewRequest() {
    this.router.navigate(['/dashboard/cct/interview-request']);
  }

  goToAssignInterview() {
    this.router.navigate(['/dashboard/cct/assign-interview']);
  }

  goToAssignBatchInterview() {
    this.router.navigate(['/dashboard/cct/assign-batch-interview']);
  }

  goToViewInterview() {
    this.router.navigate(['/dashboard/cct/view-interview']);
  }

  goToQualityMaster() {
    this.router.navigate(['/dashboard/cct/quality-master']);
  }

  goToEnrolyLogs() {
    this.router.navigate(['/dashboard/enroly-logs']);
  }
  gotoAdminNotice() {
    this.router.navigate(['/dashboard/notice']);
  }
  gotoFrontendNotice() {
    this.router.navigate(['/dashboard/notice/frontend-notice']);
  }
  gotoFrontendWebinar() {
    this.router.navigate(['/dashboard/notice/frontend-webinar']);
  }
  // ============================= //
  //          FILE MANAGER         //
  // ============================= //

  goToSharedDrive() {
    window.open('https://drive.google.com/drive/u/1/shared-drives', '_blank');
  }

  goToImportant() {
    this.router.navigate(['/dashboard/file-manager/important']);
  }

  goToSharedWithMe() {
    this.router.navigate(['/dashboard/file-manager/shared-with-me']);
  }

  goToSharedByMe() {
    this.router.navigate(['/dashboard/file-manager/shared-by-me']);
  }

  goToMyDrive() {
    this.router.navigate(['/dashboard/file-manager/my-drive']);
  }

  isTwoFactorVerified = false;

  checkTwoFactorValidity(): void {
    const stored = localStorage.getItem('twoFactorVerified');
    if (stored) {
      const { timestamp } = JSON.parse(stored);
      const now = Date.now();
      const diff = (now - timestamp) / (1000 * 60); // minutes
      if (diff > 2) {
        this.isTwoFactorVerified = false;
      } else {
        this.isTwoFactorVerified = true;
      }
    } else {
      this.isTwoFactorVerified = false;
    }
  }

  goToSwitchDrive2() {
    this.checkTwoFactorValidity();
    if (!this.isTwoFactorVerified) {
      this.openTwoFactorDialog();
    } else {
      this.router.navigate(['/dashboard/file-manager-2/switch-drive']);
    }
  }

  openTwoFactorDialog(): void {
    const dialogRef = this.dialog.open(TwoFactorVerificationComponent, {
      width: '400px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((verified: boolean) => {
      if (verified) {
        this.isTwoFactorVerified = true;
        localStorage.setItem(
          'twoFactorVerified',
          JSON.stringify({ timestamp: Date.now() })
        );
        this.router.navigate(['/dashboard/file-manager-2/switch-drive']);
      }
    });
  }

  async goToFileManager(payload: any) {
    this.LoaderService.show();

    this.fileMangerService.fileManagerV3(payload).subscribe({
      next: (res: any) => {
        const loginUrl = res.data.data.loginUrl;

        if (loginUrl) {
          const userDetails = res?.data?.userDetails;
          window.open(`${loginUrl}&userData=${encodeURIComponent(
            btoa(JSON.stringify(userDetails))
          )}`, '_blank');
          // console.log("loginUrl: ", `&userData=${encodeURIComponent(
          //   btoa(JSON.stringify(userDetails))
          // )}`);

          this.LoaderService.hide();
        } else {
          console.error('Login URL not found in response');
          this.LoaderService.hide();
        }

      }, error: (err: any) => {
        console.error("Something Went Wrong!!");
        this.LoaderService.hide();
      }
    })

  }

  async goToFileManagerV3() {

    const currentUser = await this.localStorageService.getKeyIndexedDbKey('switchUser') ? null :
      await this.localStorageService.getKeyIndexedDbKey('currentUser');

    // console.log("currentUser: ", currentUser);

    if (!currentUser) {
      const message = "You are a delegated user and do not have access to the Drive feature. Please contact the Admin for assistance if needed.";
      this.toast.successAndErrorDialog('info', message);
      return;
    } else if (currentUser.id === '132' || currentUser.id === '152' || currentUser.id === '1089') {

      const dialogRef = this.dialog.open(SwitchUserComponent, { width: '450px' });

      dialogRef.afterClosed().subscribe(result => {
        if (result.status) {
          this.goToFileManager(result.payload);
        } else if (!result.status) {
          const payload = {
            crizac_user_id: currentUser?.id,
            crizac_email: currentUser?.email,
            username: currentUser?.driveData?.userName,
          };
          this.goToFileManager(payload);
        }
      });
      return;

    } else if (currentUser?.driveData?.driveAccess === 'true'){
      const payload = {
        crizac_user_id: currentUser?.id,
        crizac_email: currentUser?.email,
        username: currentUser?.driveData?.userName,
      };
      this.goToFileManager(payload);
    }
    else{
      const message = "You do not have access to the Drive feature. Please contact the Admin for assistance if needed.";
      this.toast.successAndErrorDialog('info', message);
      return;
    }

  }

  goToMyDrive2() {
    this.router.navigate(['/dashboard/file-manager-2/my-drive-2']);
  }

  goToShares2() {
    this.router.navigate(['/dashboard/file-manager-2/shares-drive-2']);
  }

  goSharedWithMe2() {
    this.router.navigate(['/dashboard/file-manager-2/shares-with-me']);
  }

  goSharedWithOthers2() {
    this.router.navigate(['/dashboard/file-manager-2/shares-with-others']);
  }

  // ============================= //
  //            REPORTS            //
  // ============================= //

  goToReferredQC() {
    this.router.navigate(['/dashboard/referred-qc']);
  }

  goToVoucher() {
    this.router.navigate(['/dashboard/voucher']);
  }
  goToNewList(){
    this.router.navigate(['/dashboard/rule-list']);
  }

  goToAccommodation() {
    this.router.navigate(['/dashboard/accommodation']);
  }

  goToIndividualQCReports() {
    this.router.navigate(['/dashboard/individual-qc-reports']);
  }

  goToPaymentReports() {
    this.router.navigate(['/dashboard/payment-reports']);
  }
  goToApplicationReports() {
    this.router.navigate(['/dashboard/application-reports']);
  }
  goToApplicationReceived() {
    this.router.navigate(['/dashboard/application-received']);
  }
  goToAgentNotGivenApplication() {
    this.router.navigate(['/dashboard/agent-not-given-application']);
  }
  goToAgentNotPaid() {
    this.router.navigate(['/dashboard/agent-not-paid']);
  }
  goToBlockedAgents() {
    this.router.navigate(['/dashboard/blocked-agents']);
  }
  goToApplicationStatusTat() {
    this.router.navigate(['/dashboard/application-status-tat']);
  }
  goToApplicationSecondaryStatusTat() {
    this.router.navigate(['/dashboard/application-secondary-status-tat']);
  }
  goToVisaRefusals() {
    this.router.navigate(['/dashboard/visa-refusals']);
  }
  goToUserMailActivity() {
    this.router.navigate(['/dashboard/user-mail-activity']);
  }
  goToUniversityMailboxes() {
    this.router.navigate(['/dashboard/university-mailboxes']);
  }
  goToUserMail() {
    this.router.navigate(['/dashboard/user-mail']);
  }
  goToAgentList() {
    this.router.navigate(['/dashboard/agent-list']);
  }
  goToyear() {
    this.router.navigate(['/dashboard/year-on-year-report']);
  }
  dnjReports() {
    this.router.navigate(['/dashboard/dnj-report']);
  }
  applicatonFlowReport() {
    this.router.navigate(['/dashboard/application-flow-report']);
  }
  casInterview() {
    this.router.navigate(['/dashboard/cas-interview-request']);
  }
  interviewReport() {
    this.router.navigate(['/dashboard/interview-report']);
  }
  applicatonLifeline() {
    this.router.navigate(['/dashboard/application-lifeline-report']);
  }
  automationReport() {
    this.router.navigate(['/dashboard/automation-report']);
  }
  cptReport() {
    this.router.navigate(['/dashboard/cpt-report']);
  }
  agentNeverLogged() {
    this.router.navigate(['/dashboard/agent-never-logged']);
  }
  agentApprovalLog() {
    this.router.navigate(['/dashboard/agent-approval-log']);
  }
  caseOwnerReport() {
    this.router.navigate(['/dashboard/case-owner-report']);
  }
  africanReports() {
    this.router.navigate(['/dashboard/afferica-report']);
  }
  casReports() {
    this.router.navigate(['/dashboard/cas-dynamics-report']);
  }
  aiEligibilityCheckReport() {
    this.router.navigate(['/dashboard/ai-eligibility-check-report']);
  }
  // interviewerCallLogReport(){
  //   this.router.navigate(['/dashboard/interviewer-call-log-report']);
  // }
  receivedDynamicReport() {
    this.router.navigate(['/dashboard/received-dynamics-report']);
  }
  rmCallLogReport() {
    this.router.navigate(['/dashboard/rm-call-log-report']);
  }
  allUserCallLogReport() {
    this.router.navigate(['/dashboard/all-users-call-log']);
  }
  applicationReportsMM() {
    this.router.navigate(['/dashboard/application-reports-mm']);
  }
  duplicateAgentReport() {
    this.router.navigate(['/dashboard/duplicate-agent-report']);
  }
  whatsappReport() {
    this.router.navigate(['/dashboard/whatsApp-log']);
  }
  chatAnalyticsReport() {
    this.router.navigate(['/dashboard/chat-analytics-report']);
  }
  timelineReport(){
    this.router.navigate(['/dashboard/offer-tat-reports']);
  }
  globalTreeReport(){
    this.router.navigate(['/dashboard/global-tree-counsellor-report']);
  }
  recodingReport(){
    this.router.navigate(['/dashboard/call-recoding-report']);
  }


  // ============================= //
  //            COURSE MASTER      //
  // ============================= //
  goToCourseMasterCourses() {
    this.router.navigate(['/dashboard/courses']);
  }
  goToCourseMasterOptions() {
    this.router.navigate(['/dashboard/options']);
  }

  goToCourseMasterFilters() {
    this.router.navigate(['/dashboard/filters']);
  }

  // ==========END=================//

  // ============================= //
  //       ADMIN MASTER            //
  // ============================= //
  goToLoanEnquiryList() {
    this.router.navigate(['/dashboard/loan-enquiry-list']);
  }
  goToLoanList() {
    this.router.navigate(['/dashboard/loan']);
  }
  goToApplicationDeadline() {
    this.router.navigate(['/dashboard/application-deadline']);
  }
  goToOfferTimeline() {
    this.router.navigate(['/dashboard/offer-timeline']);
  }
  goToAccommodationCommission() {
    this.router.navigate(['/dashboard/accommodation-commission']);
  }
  goToAccommodationVendor() {
    this.router.navigate(['/dashboard/accommodation-vendor']);
  }
  goToInterViewType() {
    this.router.navigate(['/dashboard/interview-type']);
  }
  goToInterViewMode() {
    this.router.navigate(['/dashboard/interview-mode']);
  }
  goToInternalOtions() {
    this.router.navigate(['/dashboard/internal-options']);
  }
  goToTrainingHub() {
    this.router.navigate(['/dashboard/training-hub']);
  }
  goToDocumentRestriction() {
    this.router.navigate(['/dashboard/document-restriction']);
  }
  goToEmployeeDesignation() {
    this.router.navigate(['/dashboard/employee-designation']);
  }
  goToJobRole() {
    this.router.navigate(['/dashboard/job-role']);
  }
  goToPasswordManager() {
    this.router.navigate(['/dashboard/password-manager']);
  }
  goToOfficeLayout() {
    this.router.navigate(['/dashboard/office-layout']);
  }
  goToUserGroups() {
    this.router.navigate(['/dashboard/user-groups']);
  }
  goToUniversityContract() {
    this.router.navigate(['/dashboard/university-contract']);
  }

  goToStoreCommissions() {
    this.router.navigate(['/dashboard/store-commissions']);
  }

  goToWhatsappNumbers() {
    this.router.navigate(['/dashboard/whatsapp-numbers']);
  }

  goToWhatsappGroupsList() {
    this.router.navigate(['/dashboard/whatsapp-groups-list']);
  }
  goToApplicationAssignment() {
    this.router.navigate(['/dashboard/secondary-status-assignment-list']);
  }

  // ============================= //
  //      UNIVERSITY MASTER        //
  // ============================= //

  goToUniversity() {
    this.router.navigate(['/dashboard/university']);
  }
  goToCourse() {
    this.router.navigate(['/dashboard/courses']);
  }

  goToUniversityAffiliate() {
    this.router.navigate(['/dashboard/university_affliate']);
  }

  goToUniversityProcessLink() {
    this.router.navigate(['/dashboard/university_process_link']);
  }

  goToUniversityFilterMaster() {
    this.router.navigate(['/dashboard/university_filter_master']);
  }

  goToUniversityFilterPG() {
    this.router.navigate(['/dashboard/university_filter_pg']);
  }

  goToUniversityFilterUG() {
    this.router.navigate(['/dashboard/university_filter_ug']);
  }

  goToUniversityCoCptArt() {
    this.router.navigate(['/dashboard/university_cat_cpt_art']);
  }
  gotoAutomationLogs() {
    this.router.navigate(['/dashboard/automation']);
  }

  gotoActivityLogs() {
    this.router.navigate(['/dashboard/activity']);
  }

  gotoAutomationmailLogs() {
    this.router.navigate(['/dashboard/automation-mail']);
  }
  gotoAutomationmailFormLogs() {
    this.router.navigate(['/dashboard/automation-mail-form']);
  }
  // ========== END =================//

  // ======= CPT ========== //
  goToAssignApplications() {
    this.router.navigate(['/dashboard/cpt/assign-application']);
  }

  goToDocumentVerification() {
    this.router.navigate(['/dashboard/cpt/document-verification']);
  }

  goToProcessedApplications() {
    this.router.navigate(['/dashboard/cpt/processed-application']);
  }

  // ========== CPT END =================//

  // Dashboard
  goToDashboard() {
    this.router.navigate(['/dashboard/main-dashboard']);
  }
  goToRmDashboard() {
    this.router.navigate(['/dashboard/rm-dashboard']);
  }
  goToMmDashboard() {
    this.router.navigate(['/dashboard/mm-dashboard']);
  }
  goToApplicationDashboard() {
    this.router.navigate(['/dashboard/application-dashboard']);
  }
  goToAfricaDashboard() {
    this.router.navigate(['/dashboard/africa-dashboard']);
  }
  //application status
  goToPrimary() {
    this.router.navigate(['/dashboard/application-status/primary-status']);
  }
  goToAuto() {
    this.router.navigate(['/dashboard/application-status/auto-change-status']);
  }
  goToSecondary() {
    this.router.navigate(['/dashboard/application-status/secondary-status']);
  }
  goToInternal() {
    this.router.navigate(['/dashboard/application-status/internal-status']);
  }
  goToCommunication() {
    this.router.navigate([
      '/dashboard/application-status/communication-status',
    ]);
  }


  // ================Setting Start=================//
  goToSmtp() {
    this.router.navigate(['/dashboard/email-master/smtp']);
  }
  goToEmailTemplate() {
    this.router.navigate(['/dashboard/email-master/email-template']);
  }
  goToUniversityEmail() {
    this.router.navigate(['/dashboard/email-master/university-emails']);
  }

  //Dynamic Form
  onDynamicClick() {
    this.router.navigate(['/dashboard/dynamic-form/builder']);
  }
  onAiAutomationLogs() {
    this.router.navigate(['/dashboard/automation/ai-automation-logs']);
  }
  onAiUniversityList() {
    this.router.navigate(['/dashboard/automation/ai-university-list']);
  }

  onAiUniversityLogs() {
    this.router.navigate(['/dashboard/automation/ai-university-logs']);
  }
  onAiOfferLog() {
    this.router.navigate(['/dashboard/automation/ai-offer-log']);
  }
  // ==========END=================//

  dynamicRoute(route: string) {
    this.router.navigate([route]);
  }

  gotoWhatsappAnalytics() {
    this.router.navigate(['/dashboard/chat-master/whatsapp-analytics'])
  }

  goToWhatsappGroup() {
    this.router.navigate(['/dashboard/chat-master/whatsapp-group'])
  }

  goToWhatsappGroupAnalytics() {
    this.router.navigate(['/dashboard/chat-master/whatsapp-group-analytics'])
  }
  goToWhatsappGroupEscalations() {
    this.router.navigate(['/dashboard/chat-master/whatsapp-group-escalations'])
  }
  gotoCampaign() {
    this.router.navigate(['/dashboard/chat-master/whatsapp-campaign'])
  }

  goInboxAnalytics() {
    this.router.navigate(['/dashboard/chat-master/inbox-analytics'])
  }

  goConversationLogs() {
    this.router.navigate(['/dashboard/chat-master/conversation-logs'])
  }

  goConversationDelayLogs() {
    this.router.navigate(['/dashboard/chat-master/conversation-delay-logs'])
  }

  goToBulkMailer(route: string) {
    this.router.navigate(['/dashboard/bulk-mailer', route]);
  }

  // Audience Submenus
  goToAudienceSegments() {
    this.router.navigate(['/dashboard/bulk-mailer/audience/segments']);
  }

  goToAudienceContacts() {
    this.router.navigate(['/dashboard/bulk-mailer/audience/contacts']);
  }

  goToAudienceTags() {
    this.router.navigate(['/dashboard/bulk-mailer/audience/tags']);
  }

  goToMailSender() {
    this.router.navigate(['/dashboard/bulk-mailer/mail-sender']);
  }

  // ================ Case Owner Start =================//

  goToAllCaseList() {
    this.router.navigate(['/dashboard/cat/cat-all-case']);
  }

  goToMyCaseList() {
    this.router.navigate(['/dashboard/cat/cat-my-case']);
  }

  goToChangeCaseOwnerList() {
    this.router.navigate(['/dashboard/cat/cat-change-case-owner']);
  }

  goToLeadForm() {
    this.router.navigate(['/dashboard/lead-form']);
  }

  // ================ Case Owner End ===================//

  //====== Art ========= //

  artApplicaton() {
    this.router.navigate(['/dashboard/art/art_assignment']);
  }
  artApplicatonMy() {
    this.router.navigate(['/dashboard/art/MY_art_assignment']);
  }

  //data entry application

  dataApplicaton() {
    this.router.navigate(['/dashboard/data/data_entry']);
  }
  dataApplicatonMy() {
    this.router.navigate(['/dashboard/data/my_data_entry']);
  }
  goToMailbox() {
    window.open(`/mail`, '_blank');
  }

  private setupDomainBranding(): void {
    this.brandLogo = this.domainConfigService.getDashboardLogo();
    this.brandLogoIcon = this.domainConfigService.getDashboardLogoIcon();
  }

  goToPartnerSurvey(event: MouseEvent) {
    this.router.navigate(['/dashboard/partner-survey']);
  }

  goToLeadTracking(event: MouseEvent) {
    this.router.navigate(['/dashboard/lead-tracking']);
  }

  goToBranchOffice() {
    this.router.navigate(['/dashboard/office/branch-office']);
  }
  goToConferenceRooms() {
    this.router.navigate(['/dashboard/conference-room/rooms']);
  }
  goToCrizacMRC() {
    window.open('https://crizac-mrc-insight.lovable.app', '_blank');
  }
  goToScholarshipList() {
    this.router.navigate(['/dashboard/scholarship/scholarship-list']);
  }

  goToLeadStatus(type: string) {
    this.router.navigate([`/dashboard/lead-status/${type}-status`]);
  }

  goToLeadSource() {
    this.router.navigate([`/dashboard/lead-source`]);
  }

  goToLeadFollowupStaus() {
    this.router.navigate([`/dashboard/followup-status`]);
  }

  /**
   * Search Program — the single B2C entry that replaced "Course Search" and
   * "University Search". Lands on the Courses tab; the tab is a query param so
   * this is also what makes the two tabs linkable and back-button friendly.
   */
  searchProgram() {
    this.router.navigate(['/dashboard/programs'], { queryParams: { tab: 'courses' } });
  }
  // Unwired 2026-09-21 along with their sidebar entries — see the commented
  // block in sidebar.component.html. The routes still exist, so these keep
  // working if the entries are restored.
  universitySearch() {
    this.router.navigate(['/dashboard/university/university-list']);
  }
  courseSearch() {
    this.router.navigate(['/dashboard/course/course-list']);
  }
  universityCountryTraing() {
    this.router.navigate(['/dashboard/traing/university-country']);
  }
  trainingHub() {
    this.router.navigate(['/dashboard/traing/training-hub']);
  }
  goToEnglishVoucher(){
    this.router.navigate(['/dashboard/english-test-voucher']);
  }
  gotoMailAutomationLogs(){
    this.router.navigate(['/dashboard/mail/logs-list']);
  }
}
